// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ActiveState, Jsonld, SeoProps } from "@stoneage/App/Widgets/SearchEngineOptimization/SearchEngineOptimization";

/**
 * Activate structure based on condition
 *
 * @param SeoProps
 * @returns ActiveState
 */
const activate = ({ state }: SeoProps): ActiveState => {
    return state?.components?.breadcrumbs?.links?.length;
};

/**
 * Build the structured data
 *
 * @param SeoProps
 * @returns Jsonld
 */
const json = ({ state }: SeoProps): Jsonld => {
    const url = `https://${state?.context?.website?.uri?.split("/")[2].split(":")[0]}`;

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: state?.components?.breadcrumbs?.links?.map((item, idx) => ({
            "@type": "ListItem",
            position: idx + 1,
            item: {
                "@id": url + item.href ? item.href : "",
                name: item.children as string,
            },
        })),
    };
};

export default { activate, json };
